import React from 'react'
import PropTypes from 'prop-types'
import { Colours } from '../../style_helpers'
import styles from './styles'

const Loader = (props) => {
  return (
    <svg style={styles.loader} width={props.width} height={props.height} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g transform='translate(2 2)' fillRule='nonzero' strokeWidth='4' fill='none'>
        <circle stroke={props.backgroundColour} cx='10' cy='10' r='10' />
        <path d='M10 20c3.3141 0 6.2517-1.6122 8.0712-4.095' stroke={props.foregroundColour} strokeLinecap='round' />
      </g>
    </svg>
  )
}

Loader.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  backgroundColour: PropTypes.string,
  foregroundColour: PropTypes.string
}

Loader.defaultProps = {
  backgroundColour: Colours('grey', '200'),
  foregroundColour: Colours('grey', '500')
}

export default Loader
